import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CarouselModule} from 'primeng/carousel';
import {SlideMenuModule} from 'primeng/slidemenu';
import { TableModule } from 'primeng/table';
import { ChipModule } from 'primeng/chip';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import {TooltipModule} from 'primeng/tooltip';
import {TabViewModule} from 'primeng/tabview';
import {FocusTrapModule} from 'primeng/focustrap';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {GalleriaModule} from 'primeng/galleria';
import {ImageModule} from 'primeng/image';
import {DialogModule} from 'primeng/dialog';
import {TreeSelectModule} from 'primeng/treeselect';
import {AccordionModule} from 'primeng/accordion';
import {ListboxModule} from 'primeng/listbox';
import {TreeTableModule} from 'primeng/treetable';
import {ToolbarModule} from 'primeng/toolbar';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {BlockUIModule} from 'primeng/blockui';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CarouselModule,
    SlideMenuModule,
    TableModule,
    ChipModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    TabViewModule,
    FocusTrapModule,
    DynamicDialogModule,
    GalleriaModule,
    ImageModule,
    DialogModule,
    TreeSelectModule,
    AccordionModule,
    ListboxModule,
    TreeTableModule,
    ToolbarModule,
    ConfirmDialogModule
  ],
  exports: [
    CarouselModule,
    SlideMenuModule,
    TableModule,
    ChipModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    TabViewModule,
    FocusTrapModule,
    DynamicDialogModule,
    GalleriaModule,
    ImageModule,
    DialogModule,
    TreeSelectModule,
    AccordionModule,
    ListboxModule,
    TreeTableModule,
    ToolbarModule,
    ConfirmDialogModule
  ]
})
export class PrimengModule { }
